export default "__VITE_ASSET__laXfHsyE__"